/**
 * Checks if a number is less than a specified maximum value
 * @example
 * const isUnder10 = isIntUnder(10);
 * isUnder10(5); // returns true
 * isUnder10(15); // returns false
 */
export const isIntUnder = (max: number) => (value: number) => {
    return value < max;
}